<form [formGroup]="loginForm" (ngSubmit)="loginFormSubmit()" novalidate>
  <tc-form-group>
    <tc-input [prefixIcon]="'icofont-user-alt-7'" [placeholder]="'Email'" formControlName="login"></tc-input>
  </tc-form-group>
  <tc-form-group>
    <tc-input [prefixIcon]="'icofont-lock'" [placeholder]="'Password'" [type]="'password'" formControlName="pass"></tc-input>
  </tc-form-group>
  <div class="col-12" align="center">

    <p> By clicking Login, you agree to our <a [routerLink]="['../', 'terms']">Terms and
      Conditions</a> and that you have read our
     <a [routerLink]="['../', 'privacy']">Privacy Policy</a> </p>
  
    <button style="background: #47941b !important;"tc-button [view]="'accent'">
      Login
    </button> &nbsp;&nbsp;
    <button 
    tc-button
    [view]="'accent'" style="background: #47941b !important;" (click)=" backClicked()">
      Back
    </button> 
  </div>
  <div class="col-12 " align="center" style="padding-top: 5%;">
      <button style="width: 75%;" class="btn btn-social-icon btn-google" (click)="signInWithGoogle()"><tc-icon [iconClass]="'icofont-google-plus'" class="iconColor"></tc-icon>Sign In with Google</button>
  </div>  
  <div class="col-12 " align="center" style="padding-top: 2%;">
    <!-- <button style="width: 75%;" class="btn btn-social-icon btn-facebook" (click)="signInWithFB()"><tc-icon [iconClass]="'icofont-facebook'" class="iconColor"></tc-icon>Sign In with Facebook</button> -->
  </div>
</form>
